import { useTheme } from 'hooks/theme';
import { SVGProps } from 'react';
import { CONFIG_ICON } from './config-icon';

const InformationIcon = (props: SVGProps<SVGSVGElement>) => {
  const { theme } = useTheme();
  const config_icon = CONFIG_ICON[theme];

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={32}
      height={32}
      fill="none"
      {...props}
    >
      <path
        fill={config_icon.secondary}
        d="M22 8H10v2h12V8ZM22 16H10v2h12v-2ZM18 12h-8v2h8v-2ZM20 20H10v2h10v-2Z"
      />
      <path
        fill={config_icon.secondary}
        d="M5.981 4v24H26l-1-1-1-1-15.842-.177V6.177h15.684L24 26l1 1 1 1 .02-24H5.98Z"
      />
    </svg>
  );
};

export default InformationIcon;
